import { Datalayer, DatalayersMap, getDistinctValues, getKeyAsRanges, groupBy, IDatalayerKey, IDataLayerType, isNumber, LayerViewModel, runOnLayersLoaded, selectMany } from "../omnia"

export function updateKeys(map: DatalayersMap, layers: LayerViewModel[]) {

    return runOnLayersLoaded(layers, () => {

        const keys = map.getLayers()
            .filter(l => l instanceof Datalayer)
            .map(m => layers.find(l => l.mapLayer == m))
            .filter(l => !!l)
            .map(l => ({
                type: l.type,
                key: l.mapLayer.getKey()
            }))
            .filter(i => i.key)
            .filter(i => shouldIncludeType(i.type))
            .map(i => i.key)

        const groups = groupBy(keys, k => k, k => k.id)

        const resultingKeys = groups
            .map(g => ({ id: g.key.id, name: g.key.name || "", entries: mergeKeys(g.values) }))
            .filter(l => l.entries.length > 0)
            .sort((a, b) => a.name.localeCompare(b.name))

        map.keys = resultingKeys

        return resultingKeys

    })

}

function mergeKeys(keys: IDatalayerKey[]) {

    const key1 = keys[0]

    const flat = selectMany(keys.map(k => k.layerKey))

    if (key1.numeric && (!key1.fixed)) {

        return getKeyAsRanges(flat, key1.unit ? " " + key1.unit : "")

    }

    const distinct = getDistinctValues(flat, f => f, f => f.text)

    const fixed = key1.fixed

    const sorted = distinct.sort((a, b) => {

        if (key1.numeric && isNumber(a.value) && isNumber(a.value)) {
            return a.value - b.value
        }

        return fixed
            ? 0
            : a.text.localeCompare(b.text)

    })

    return sorted

}

function shouldIncludeType(type: IDataLayerType) {
    // TODO: decide if some types should be ignored (EC scan?), and how
    return true
}
